import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { vernonNjConfig } from "./data";

export default function VernonNJPage() {
  return <CityPageTemplate config={vernonNjConfig} />;
}